import { render, staticRenderFns } from "./BatteryAlerts.vue?vue&type=template&id=64b85fdc"
import script from "./BatteryAlerts.vue?vue&type=script&lang=js"
export * from "./BatteryAlerts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports